import React, { FC, PropsWithChildren } from "react";
import cn from "classnames";
import stl from "./index.module.scss";
import bg from "../../assets/images/bg-main.png";
import { popupContainerClass } from "../../shared/getPopupContainer";
import { Button, Grid } from "../../components";
import { useStore } from "effector-react";
import { SettingsEndpoint } from "../../store/endpoints";
import { FiArrowLeft, FiInfo } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { usePageSize } from "../../hooks";
import BookingDetailsMobile from "../AsideMobile";
import Aside from "../Aside";
import { AppConfig } from "../../config";

interface Props {
  className?: PropsWithChildren<HTMLDivElement>["className"];
  hideAside?: boolean;
}

const Main: FC<Props> = ({ className, hideAside, children }) => {
  const { t } = useTranslation(AppConfig.translationFileNames.base);
  const pageSize = usePageSize();
  const { data: settings } = useStore(SettingsEndpoint.store);

  return (
    <div
      className={cn(className, stl.block)}
      style={{ backgroundImage: `url(${settings?.background_image ?? bg})` }}
    >
      {(settings?.website_url || settings?.phone) && pageSize.md && (
        <div className={stl.additionalControls}>
          <Grid container>
            {settings?.website_url && (
              <Grid item xs={6} className={stl.left}>
                <Button
                  variant={"help"}
                  size={"small"}
                  href={settings.website_url}
                  target={"_blank"}
                  rel={"noreferrer"}
                  icon={<FiArrowLeft />}
                >
                  {t("backToWebsite")}
                </Button>
              </Grid>
            )}

            {settings?.phone && (
              <Grid item xs={6} className={stl.right}>
                <Button
                  className={stl.helpBtn}
                  variant={"help"}
                  size={"small"}
                  href={`tel:${settings.phone}`}
                  icon={<FiInfo />}
                >
                  {t("callUs.q")}
                  <i style={{ marginLeft: 5 }}>
                    {t("callUs.r")} {settings.phone}
                  </i>
                </Button>
              </Grid>
            )}
          </Grid>
        </div>
      )}

      <div className={cn(stl.container, popupContainerClass)}>
        {!pageSize.md && <BookingDetailsMobile />}
        <div className={stl.inner}>
          {!hideAside ? (
            <Grid container>
              <Grid item md={9} xs={12} order={{ md: 1, xs: 2 }}>
                {children}
              </Grid>
              {pageSize.md && (
                <Grid item md={3} xs={12} order={{ md: 2, xs: 1 }}>
                  <Aside />
                </Grid>
              )}
            </Grid>
          ) : (
            children
          )}
        </div>
      </div>
    </div>
  );
};

export default Main;
